import axios from "axios";

const login = async (data) => {
  const params = {
    email: data.email,
    password: data.password,
  };
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/Login`,
      params,
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const verifyLogin2FA = async ({ code, tempToken }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/2fa/login-verify`,
      { tempToken, code },
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

const forgetpassword = async (data) => {
  const params = new FormData();
  params.append("email", data.email);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/Forgot-Otp`,
      params,
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const otpverify = async (data, token) => {
  const otpno = Number(data);
  const params = {
    otp: otpno,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/Forgot-Otp-Verification`,
      params,
      {
        headers: {
          Authentication: token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const resetpassword = async (data, token) => {
  const params = new FormData();
  params.append("new_password", data);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/New-Password`,
      params,
      {
        headers: {
          Authentication: token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export default login;
export { forgetpassword, otpverify, resetpassword, verifyLogin2FA };
